<template>
    <div>
        <b-alert v-for="validation in validations" :key="validation.id" show :variant=validationType(validation) class="mb-2">{{validation.message}}</b-alert>
    </div>
</template>

<script>
import { resolve } from 'url';
export default {
    props: ["validations"],
    methods: {
        validationType(validation) {
            if(validation.isError) return "danger";
            if(validation.isWarning) return "warning";
            if(validation.isInformation) return "info"
            return "primary";
        }
    }
}
</script>

<style>

</style>
